import { RegistrationStepProps } from 'screens/Registration/types'
import Styles from './GetStarted.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button/Button'

export const GetStarted: React.FC<RegistrationStepProps> = ({ onNext }) => {
  return (
    <div className={Styles.container}>
      <div className={Styles.leftContent}>
        <div className={Styles.title}>
          <Heading level={1}>Get extraordinary marketing in 7 minutes</Heading>
          <Text color="var(--dark-60)">
            Simple setup, powerful results. Define your preferences and watch Blaze create and publish content daily.
          </Text>
        </div>
        <Button size="xl" onPress={onNext}>
          Get Started
        </Button>
      </div>
      <div className={Styles.rightContent}>
        <img
          src="https://res.cloudinary.com/almanac/image/upload/v1765477790/blaze_assets/virtual_marketer/onboarding/grid_1_cc93my.png"
          alt="grid1"
        />
        <img
          src="https://res.cloudinary.com/almanac/image/upload/v1765477790/blaze_assets/virtual_marketer/onboarding/grid_2_q1n2e1.png"
          alt="grid2"
        />
        <img
          src="https://res.cloudinary.com/almanac/image/upload/v1765477791/blaze_assets/virtual_marketer/onboarding/grid_3_x5bua6.png"
          alt="grid3"
        />
        <img
          src="https://res.cloudinary.com/almanac/image/upload/v1765477791/blaze_assets/virtual_marketer/onboarding/grid_4_uq4qyw.png"
          alt="grid4"
        />
      </div>
    </div>
  )
}
